<div class="form-dialog-wrapper">
    <h2
        mat-dialog-title
        [attr.data-testid]="'title' | testid: testIdName()"
    >
        {{ title() }}
    </h2>

    <mat-dialog-content>
        <ng-content [attr.data-testid]="'content' | testid: testIdName()"></ng-content>
    </mat-dialog-content>
    <mat-dialog-actions>
        <app-dynamic-actions
            [actions]="actions()"
            [testIdPrefix]="testIdName()"
        >
        </app-dynamic-actions>
    </mat-dialog-actions>
</div>
